import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 79E1B678-8458-4750-9EE0-C5CE7E57E9F1
 * name ethernet-cable-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ethernet-cable-off.svg
 * tags
 */
export const EthernetCableOffIcon = createSvgIcon(<><path d="M11,3H13V7H11V3M8,4H10V8H14V4H16V11H12.82L8,6.18V4M20,20.72L18.73,22L14,17.27V22H10V13.27L2,5.27L3.28,4L20,20.72Z" /></>, 'EthernetCableOffIcon');
export default EthernetCableOffIcon